import React from "react";
import { useNavigate } from "react-router-dom";
import styled from "styled-components";
import { Colors, SIDEBAR_ITEMS } from "../../config/Constants";
import SidebarItems, { SidebarItem } from "./SidebarItems";
import Logo from "../Topbar/Logo";
import Icon from "./Icon";
import { useIsAuthenticated } from "@azure/msal-react";

const closeIcon = require("../../assets/images/close_white.png");

const Sidebar = ({
  onClose,
  activePath,
  onRoute,
  setOpenLogoutModal,
  hideBizTrip,
}) => {
  const navigate = useNavigate();
  const onItemClick = (path) => {
    navigate(path);
    onClose();
  };
  const handleLogout = () => {
    setOpenLogoutModal(true);
  };
  const isAuthenticated = useIsAuthenticated();
  return (
    <>
      <BackdropWrapper onClick={onClose}></BackdropWrapper>
      <SidebarContainer>
        <Wrapper>
          <div>
            <Topbar>
              <LogoWrapper>
                <Logo />
              </LogoWrapper>
              <XMark src={closeIcon} alt="close" onClick={onClose} />
            </Topbar>
            <SidebarWrapper>
              {SIDEBAR_ITEMS.filter(
                (item, idx) => !(hideBizTrip && item.path === "business"),
              ).map((eachItem, idx) => {
                if (eachItem.path === "pin") {
                  if (!isAuthenticated)
                    return (
                      <SidebarItems
                        key={idx}
                        onClick={() => onItemClick(eachItem.path)}
                        path={eachItem.path}
                        labeltext={eachItem.label}
                        isActive={activePath === eachItem.path}
                      />
                    );
                } else {
                  return (
                    <SidebarItems
                      key={idx}
                      onClick={() => onItemClick(eachItem.path)}
                      path={eachItem.path}
                      labeltext={eachItem.label}
                      isActive={activePath === eachItem.path}
                    />
                  );
                }
              })}
            </SidebarWrapper>
          </div>
          <Logout onClick={handleLogout}>
            <SidebarItem>
              <Icon path="logout" />
              <Logoutlabel>Logout</Logoutlabel>
            </SidebarItem>
          </Logout>
        </Wrapper>
      </SidebarContainer>
    </>
  );
};

export default Sidebar;

const BackdropWrapper = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100vh;
  background-color: rgba(0, 0, 0, 0.5);
  display: block;
  z-index: 2;
  cursor: pointer;
`;
const SidebarContainer = styled.div`
  position: fixed;
  background: linear-gradient(
    270.03deg,
    #071a29 0.03%,
    #132736 48.23%,
    #091d2b 99.98%
  );
  top: 0;
  right: 0;
  height: 100vh;
  transform: translate(0%);
  transition: all 0.4s;
  z-index: 2;
  overflow: hidden scroll;
  width: 30rem;
  @media only screen and (max-width: 480px) {
    width: 100%;
  }
`;
const Wrapper = styled.div`
  padding: 0rem 2.25rem;
  height: 95vh;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
`;
const SidebarWrapper = styled.div`
  display: flex;
  flex-direction: column;
`;
const Topbar = styled.div`
  padding: 1.95rem 0 1rem 0;
  display: flex;
  justify-content: space-between;
  align-items: center;
  @media only screen and (min-width: 480px) {
    justify-content: flex-end;
  }
`;
const XMark = styled.img`
  cursor: pointer;
`;
const Logout = styled.div`
  padding-bottom: 5rem;
`;
const Logoutlabel = styled.div`
  font-weight: 500;
  font-size: 1.25rem;
  color: ${Colors.white};
`;
const LogoWrapper = styled.div`
  display: none;
  @media only screen and (max-width: 479px) {
    display: block;
  }
`;
